import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';
import Fragments from './fragments';

export const USER_GROUP_SAVED = gql`
  subscription userGroupSaved {
    userGroupSaved {
      userGroup {
        ...userGroup
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${Fragments.userGroup}
  ${CommonFragments.messageHeaders}
`;

export const USER_X_GROUP_SAVED = gql`
  subscription userXGroupSaved {
    userXGroupSaved {
      userGroupId
      userId
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const USER_X_GROUP_DELETED = gql`
  subscription userXGroupDeleted {
    userXGroupDeleted {
      userGroupId
      userId
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;
